import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Supplier } from '../../../shared/models/supplier.model';
import { NotificationService } from '../../../shared/services/notification.service';
import { SuppliersService } from '../../../shared/services/suppliers.service';
import { SupplierFormComponent } from '../supplier-form/supplier-form.component';

@Component({
  standalone: false,
  selector: 'app-supplier-update',
  templateUrl: './supplier-update.component.html',
})
export class SupplierUpdateComponent {
  @Output() afterSupplierSave = new EventEmitter<Supplier>();
  @ViewChild(SupplierFormComponent, { static: false }) form: SupplierFormComponent;

  loading = false;
  model: Supplier;

  constructor(
    public supplierService: SuppliersService,
    public router: Router,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    titleService: Title
  ) {
    titleService.setTitle('Supplier update');
  }

  afterSave(supplier: Supplier): void {
    this.afterSupplierSave.emit(supplier);
  }
}
